/* eslint-disable @typescript-eslint/naming-convention */

export enum TabTypeEnum {
  ALL = 'ALL',
  APPROVAL = 'APPROVAL',
  SHIPMENT = 'SHIPMENT',
  FULFILLMENT = 'FULFILLMENT',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export type TAB_TYPE = `${TabTypeEnum}`;

export type FormType = 'CREATE' | 'VIEW' | 'UPDATE';
